import { COLLECTIONS, isAllowedAdminEmail } from '__constants__'
import { doc, setDoc } from 'firebase/firestore'

import firestore from 'services/firebase/firestore'

const { USERS } = COLLECTIONS

/**
 * Save the user's data to the database.
 * @returns A promise that resolves to the user object.
 */
const saveUserToDB = ({ _id, email, avatarUrl, agreement, gdpr, onError }) => {
  return setDoc(doc(firestore, USERS, _id), {
    _id,
    email,
    emailVerified: false,
    agreement,
    gdpr,
    avatarUrl,
    isAdmin: isAllowedAdminEmail(email)
  }).catch((err) => {
    onError && onError(err)
  })
}

export default saveUserToDB
